import Utils from '../utils';
import { ERROR_MESSAGES } from '../constants';
import PrefectureMultiModal from '../components/prefecture_multi_modal.vue';
import validator from 'validator';
import { emailValidationOptions } from '../../shared/email_validation_options.js';

const emailDomains = [
  'gmail.com',
  'yahoo.co.jp',
  'icloud.com',
  'docomo.ne.jp',
  'ezweb.ne.jp',
  'softbank.ne.jp',
  'outlook.com',
  'hotmail.com',
  'au.com',
];
const urlParams = new URLSearchParams(window.location.search);

export default {
  data() {
    let defaultBirthYear = '';
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('ver') && urlParams.get('ver') === 'issue_4837') {
      const DEFAULT_AGE_OFFSET = 45;
      defaultBirthYear =
        (new Date().getFullYear() - DEFAULT_AGE_OFFSET).toString() + '年';
    }
    return {
      isMounted: false,
      inputItems: {
        licenses: [],
        experiences: [],
        prefecture: '',
        birthYear: defaultBirthYear,
        name: '',
        tel: '',
        email: '',
        terms: true,
      },
      errorMessages: {
        license: '',
        experience: '',
        prefecture: '',
        birthYear: '',
        name: '',
        tel: '',
        email: '',
        terms: '',
      },
      step: 1, // 横ステップで使用
      selectedPrefectureDone: false,
      selectedBirthYearDone: false,
      params: [],
      emailSuggestions: [],
    };
  },
  components: {
    PrefectureMultiModal,
  },
  mounted() {
    this.isMounted = true;
    const params = this.parseParams();
    this.params = params;
  },
  computed: {
    isLicensesValid() {
      return this.inputItems.licenses.length >= 1;
    },
    isExperiencesValid() {
      return this.inputItems.experiences.length >= 1;
    },
    isPrefecturesValid() {
      if (!this.isMounted) {
        return false;
      }

      if (this.$refs.prefectures == undefined) {
        return this.inputItems.prefecture !== '';
      }

      return this.$refs.prefectures.isValid;
    },
    isBirthyearValid() {
      return this.inputItems.birthYear !== '';
    },
    isTelValid() {
      this.inputItems.tel = Utils.zenkakuHankaku(this.inputItems.tel);
      return /^\d{10,11}$/.test(this.inputItems.tel);
    },
    isEmailValid() {
      this.inputItems.email = Utils.zenkakuHankaku(this.inputItems.email);
      return validator.isEmail(this.inputItems.email, emailValidationOptions());
    },
    isNameValid() {
      this.inputItems.name = Utils.zenkakuHankaku(this.inputItems.name);
      return this.inputItems.name.length > 1;
    },
    isTermsValid() {
      return this.inputItems.terms;
    },
    isAllValid() {
      return (
        this.isLicensesValid &&
        this.isExperiencesValid &&
        this.isPrefecturesValid &&
        this.isBirthyearValid &&
        this.isTelValid &&
        this.isNameValid &&
        this.isEmailValid &&
        this.isTermsValid
      );
    },
  },
  methods: {
    updateShowJobCard() {
      const jobCard = document.querySelector('#js-job_card');
      if (!jobCard) return;
      // step2以降は非表示のため `.u-dis-none`クラスを追加する
      if (this.step > 1) {
        jobCard.classList.add('u-dis-none');
      } else {
        jobCard.classList.remove('u-dis-none');
      }
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    parseParams() {
      const search = window.location.search.substring(1);
      if (search.length <= 0) {
        return {};
      }

      const params = JSON.parse(
        `{"${decodeURI(search)
          .replace(/"/g, '\\"')
          .replace(/&/g, '","')
          .replace(/=/g, '":"')}"}`
      );
      Object.keys(params).forEach((key) => {
        params[key] = params[key].split(',');
      });
      return params;
    },
    handleLicenses() {
      this.errorMessages.license = this.isLicensesValid
        ? ''
        : ERROR_MESSAGES.LICENSE;
    },
    handleExperiences() {
      this.errorMessages.experience = this.isExperiencesValid
        ? ''
        : ERROR_MESSAGES.EXPERIENCE;
    },
    selectPrefectureChangeHandler() {
      if (this.isPrefecturesValid) {
        this.errorMessages.prefecture = '';

        if (!this.selectedPrefectureDone) {
          this.selectedPrefectureDone = !this.selectedPrefectureDone;
        }
      } else {
        this.errorMessages.prefecture = ERROR_MESSAGES.PREFECTURE;
      }
    },
    selectChangeHandler() {
      if (this.isBirthyearValid) {
        this.errorMessages.birthYear = '';

        if (!this.selectedBirthYearDone) {
          this.selectedBirthYearDone = !this.selectedBirthYearDone;
        }
      } else {
        this.errorMessages.birthYear = ERROR_MESSAGES.BIRTHYEAR;
      }
    },
    btnClickHandler(nextStep) {
      this.step = nextStep.replace('step', '');
    },
    handleNameInput() {
      this.errorMessages.name = this.isNameValid ? '' : ERROR_MESSAGES.NAME;
    },
    handleTelInput() {
      this.errorMessages.tel = this.isTelValid ? '' : ERROR_MESSAGES.TEL;
    },
    handleEmailInput() {
      if (
        urlParams.has('ver') &&
        urlParams.get('ver') === 'issue_4616' &&
        !this.isDomainSelected
      ) {
        // メールアドレスの入力値を取得
        const emailInput = this.inputItems.email;

        // '@' 以降の文字列を取得
        const domainPart = emailInput.split('@')[1];

        // すでに主要なドメインが入力されている場合はreturn
        if (domainPart && emailDomains.includes(domainPart)) {
          this.emailSuggestions = [];
          return;
        }

        // 入力されている文字列を基にドメイン候補をフィルタリング
        if (emailInput.endsWith('@')) {
          this.emailSuggestions = emailDomains; // ドメイン一覧を表示
        } else if (domainPart) {
          this.emailSuggestions = emailDomains.filter((domain) =>
            domain.startsWith(domainPart)
          );
        } else {
          this.emailSuggestions = [];
        }
      }

      // エラーメッセージの表示
      this.errorMessages.email = this.isEmailValid ? '' : ERROR_MESSAGES.EMAIL;
    },

    // 候補を選択した場合の処理
    selectEmailSuggestion(suggestion) {
      // 入力したメールアドレスに選択されたドメインを補完
      this.isDomainSelected = true;
      this.inputItems.email =
        this.inputItems.email.split('@')[0] + '@' + suggestion;
      this.errorMessages.email = this.isEmailValid ? '' : ERROR_MESSAGES.EMAIL;
      this.emailSuggestions = []; // 候補リストを消去
    },
    handleTerms() {
      this.errorMessages.terms = this.isTermsValid ? '' : ERROR_MESSAGES.TERMS;
    },
    handleSubmit() {
      if (this.isAllValid) {
        const form = document.getElementById('js-entry_member_form');
        const submitButton = document.getElementById('js-submit_button');
        submitButton.textContent = '送信中...';
        submitButton.disabled = true;
        // submit
        form.submit();
      } else {
        const errors = [];
        Object.keys(this.errorMessages).forEach((key) => {
          if (errors.length >= 1 || key === 'terms') {
            return;
          }
          if (this.errorMessages[key] !== '') {
            errors.push(Utils.camelToSnake(key));
          }
        });
        if (errors.length > 0) {
          const nextPos = $(`.c-panel__item#${errors[0]}`).offset().top;
          $('html, body').animate({ scrollTop: nextPos - 40 }, 700, 'swing');
        }
      }
    },
  },
  watch: {
    step(newStep) {
      const stepBar = document.querySelector('[data-js="step-class"]');
      if (stepBar) {
        stepBar.dataset.step = newStep;
      }
      this.updateShowJobCard();
      this.scrollToTop();
    },
  },
};
